import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchPromotion, editPromotion, deletePromotion, clearPromotionsErrors } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import EditItem from '../components/promotions/EditPromotion';
import Alert from '../components/home/Alert';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  promotions: PropTypes.object,
  promotion: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
};

class PromotionEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchPromotion(this.props.params.id));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.promotions.promotion && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Promotion edited succesfully!',
        error: false,
      });
    }
  }
  deletePromotion(promotionId) {
    const promotions = this.props.promotions;
    promotions.delete = true;
    this.setState({ promotions });
    this.props.dispatch(deletePromotion(promotionId));
    browserHistory.push('/promotions?page=1');
  }
  saveEditPromotion(promotion) {
    const pPromotion = promotion;
    delete pPromotion.uses;
    delete pPromotion.active;
    this.setState({
      edited: true,
    });
    this.props.dispatch(editPromotion(pPromotion));
  }
  navigateToView(promotion) {
    const pPromotion = promotion;
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState(nextState);
    delete pPromotion.uses;
    delete pPromotion.active;
    this.props.dispatch(editPromotion(pPromotion));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearPromotionsErrors());
    if (!this.state.error) {
      if (this.state.viewRedirect === true) {
        this.setState({ viewRedirect: false });
        browserHistory.push(`/promotions/view/${this.props.promotion.id}`);
      } else {
        browserHistory.push('/promotions?page=1');
      }
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="promotion component" style={authPage}>
        {/* <h2>Edit Promotion</h2> */}
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
          <EditItem
            promotion={this.props.promotion}
            onSave={data => this.saveEditPromotion(data)}
            onDelete={data => this.deletePromotion(data)}
            onView={data => this.navigateToView(data)}
          />
      </div>
    );
  }
}

PromotionEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

PromotionEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    promotions: state.promotions,
    promotion: state.promotions.promotion,
    error: state.promotions.error,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(PromotionEditPage));



// WEBPACK FOOTER //
// ./src/containers/PromotionEditPage.js